"use client";

import React from "react";
import { motion } from "framer-motion";
import { SectionReveal } from "./SectionReveal";
import { Car, ShieldCheck, CalendarCheck } from "lucide-react";

const FEATURES = [
  {
    id: 1,
    title: "Premium Fleet",
    description:
      "Choose from a growing range of quality cars and bikes, available for Self Drive, Self Ride, Chauffeur and Rider services.",
    icon: Car,
  },
  {
    id: 2,
    title: "Transparent Pricing",
    description:
      "Clear package pricing with applicable KM, hours, extra charges, fees and taxes shown before you confirm your booking.",
    icon: ShieldCheck,
  },
  {
    id: 3,
    title: "Seamless Booking",
    description:
      "Easy online booking with convenient vehicle selection, secure payment and instant booking confirmation.",
    icon: CalendarCheck,
  },
];

export function IKWhyChoose() {
  return (
    <SectionReveal
      className="relative py-8 sm:py-10 md:py-12 lg:py-16"
      aria-labelledby="why-choose-heading"
    >
      <div className="container mx-auto px-4 md:px-6">
        <motion.h2
          id="why-choose-heading"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.4, ease: [0.22, 0.61, 0.36, 1] }}
          className="text-3xl md:text-4xl font-bold text-[#131222] dark:text-white text-center mb-8 md:mb-10"
        >
          Why Choose I K TOURS AND TRAVELS
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {FEATURES.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 1.2, ease: [0.22, 0.61, 0.36, 1], delay: index * 0.1 }}
                className="group rounded-xl bg-white dark:bg-neutral-900/50 border border-neutral-200/60 dark:border-neutral-700/60 hover:border-[#FFB51D]/40 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-6 md:p-8 flex flex-col items-center text-center"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center text-[#131222] dark:text-white group-hover:text-[#FFB51D] transition-colors">
                  <IconComponent
                    className="w-8 h-8"
                    strokeWidth={1.5}
                    aria-hidden
                  />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#131222] dark:text-white group-hover:text-[#FFB51D] transition-colors mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-base text-neutral-600 dark:text-neutral-400 leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </SectionReveal>
  );
}
